import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as session from "./session";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({ accessToken: null, currentUser: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = session.subscribe(setAuth);
    session.restoreSession().finally(() => setLoading(false));
    return unsubscribe;
  }, []);

  const value = useMemo(() => ({
    ...auth,
    loading,
    login: session.login,
    logout: session.logout,
  }), [auth, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth must be used inside AuthProvider");
  return value;
};
